// Display for Sources Options sidebar
// note: confluence_cloud is special, and will show first in facets regardless of order here

export const SourceSpecs = [
    {
        url:     "confluence_cloud",
        display:  "ACCESS Documentation",
        order: 1
    },  
    {
        url:     "access-ci.org",
        display:  "ACCESS Home",
        order: 2
    },
    {
        url: "operations.access-ci.org",
        display:  "ACCESS Operations Portal",
        order: 3
    },
    {
        url: "support.access-ci.org"  ,
        display: "ACCESS Support Portal",
        order: 4
    },
    {
        url: "allocations.access-ci.org",
        display:  "ACCESS Allocations Portal",
        order: 5
    },
    {
        url: "metrics.access-ci.org",
        display:   "ACCESS Metrics",
        order: 5
    },    
    {
        url: "identity.access-ci.org",
        display:   "ACCESS Identity Management",
        order: 5
    },    
    {
        url: "ask.cyberinfrastructure.org",
        display: "Ask.CI" ,
        order: 6
    },
    {
        url:     "nsf-access.atlassian.net",
        display: "ACCESS Support Documentation",
        order: 7
    },   
    {
        url: "osc.github.io",
        display:  "Open OnDemand Docs",
        order: 8
    },
    {
        url: "openondemand.org",
        display : "Open OnDemand",
        order: 9
    },    
    {
        url: "curc.readthedocs.io",
        display: "CU Research Computing Docs",
        order: 10
    },
    {
        url: "pegasus.isi.edu" ,
        display: "Pegasus Docs" ,
        order: 11
    },
    {
        url: "www.rcac.purdue.edu",
        display: "Anvil",
        order: 12
    },
    {
        url: "www.psc.edu" ,
        display: "Bridges-2 User Guide" ,
        order: 13
    },
    {
        url: "open.xdmod.org" ,
        display: "Open XDMoD Docs" ,
        order: 14
    },
    {
        url: "xdmod.ccr.buffalo.edu" ,
        display: "XDMoD User Manual" ,
        order: 15
    },
    {
        url: "docs.globus.org",
        display: "Globus Docs",
        order: 16
    }                                                        
];

